import { Colors, Icon16, IconButton24, IconNames16, IconNames8, Spinner } from '@pinpointhq/thumbtack';
import * as React from 'react';
import { DebounceInput } from 'react-debounce-input';

interface ISearchFieldProps {
  autoComplete?: string;
  canClear?: boolean;
  clear?: boolean;
  debounceTimeout?: number;
  disabled?: boolean;
  id?: string;
  isSearching?: boolean;
  name?: string;
  placeholder?: string;
  readOnly?: boolean;
  value?: string;
  width?: string;
  willUpdateUrl?: boolean;
  handleChange(searchTerm: string): void;
  handleFocus?(): void;
  handleKeyDown?(event: React.KeyboardEvent<HTMLInputElement>): void;
}

/**
 * TODO: Needs to be updated to use Thumbtack components and use debounce from Lodash instead.
 */
export function SearchField(props: ISearchFieldProps) {
  const {
    canClear = true,
    clear = false,
    disabled = false,
    debounceTimeout = 500,
    handleFocus,
    handleKeyDown,
    handleChange: parentHandleChange,
    id,
    isSearching = false,
    name = 'search',
    placeholder = 'Search...',
    readOnly = false,
    width = '100%',
    willUpdateUrl = false,
    value: defaultValue,
  } = props;
  const [value, setValue] = React.useState<string>(defaultValue || '');
  const input = React.createRef<any>();

  const updateURIParam = (searchTerm: string) => {
    const params = new URLSearchParams(window.location.search);
    if (params.has('search')) {
      params.set('search', searchTerm);
    } else {
      params.append('search', searchTerm);
    }
    if (params.get('search') === '') {
      params.delete('search');
    }
    window.history.replaceState({}, '', `${window.location.pathname}?${params}`);
  };

  React.useEffect(() => {
    updateParamState();
  }, []);

  React.useEffect(() => {
    if (clear) handleClear();
  }, [clear]);

  const updateParamState = () => {
    const params = new URLSearchParams(window.location.search);
    const searchParam = params.get('search');
    if (searchParam) handleChange(searchParam);
  };

  const onChange = (event: React.SyntheticEvent) => {
    handleChange((event.target as HTMLInputElement).value);
  };

  const handleChange = (searchTerm: string) => {
    if (willUpdateUrl) updateURIParam(searchTerm);
    setValue(searchTerm);
    parentHandleChange(searchTerm);
  };

  const handleClear = () => {
    handleChange('');
  };

  const searchingIcon = <Spinner small={true} />;
  const clearIcon = <IconButton24 icon={IconNames8.CROSS} onClick={handleClear} />;

  return (
    <div className="search" style={{ width }}>
      <Icon16 icon={IconNames16.SEARCH} fill={Colors.GREY_30} />
      <DebounceInput
        className="search__input"
        debounceTimeout={debounceTimeout}
        element="input"
        id={id}
        inputRef={input}
        name={name}
        onFocus={handleFocus}
        onKeyDown={handleKeyDown}
        placeholder={placeholder}
        style={{ width, paddingTop: '0.6em', paddingBottom: '0.6em' }}
        type="text"
        {...{ onChange, value }}
        readOnly={readOnly}
        disabled={disabled}
      />
      {isSearching ? searchingIcon : canClear && value && clearIcon}
    </div>
  );
}

export default SearchField;
